module.exports = __webpack_public_path__ + "static/media/greenblob.c333e76a.svg";